<div class="ui segment" id="wrapper" appPadding="0">
  <div class="sub-header" appPadding paddingX="15" paddingY="5">
    Select the app you want to access
  </div>
  <div class="ui basic segment" *ngIf="apps && apps.length < 1">
    <app-no-record-found
      message="You do not have access to any application"
    ></app-no-record-found>
  </div>
  <div class="slide-container" *ngIf="apps && apps.length > 0">
    <div class="nav">
      <i class="caret left teal big icon link" (click)="slidePrev()"></i>
    </div>
    <div
      class="slide-wrapper"
      [ngStyle]="{
        width: checkPermission('INVOICES_AND_PAYMENTS', 'read')
          ? '770px'
          : '100%'
      }"
    >
      <swiper
        #swiperRef
        [config]="config"
        (swiper)="onSwiper($event)"
        (slideChange)="onSlideChange()"
      >
        <ng-template
          swiperSlide
          *ngFor="
            let app of apps;
            let i = index;
            let even = even;
            let odd = odd
          "
        >
          <a
            href="{{ baseUrl }}/identity/continue/?return_url={{
              app?.applicationHost
            }}"
            target="_blank"
          >
            <div fxLayout="row" fxLayoutGap="5px" class="app-item">
              <div>
                <div
                  class="ui circular big label app-initial"
                  [style.background]="app.color"
                >
                  {{ app?.applicationName | truncate: 1:false }}
                </div>
              </div>
              <div class="app-body">
                <h3 class="ui primary header" appMargin marginB="2">
                  {{ app?.applicationName }}
                </h3>
                <p class="app-desc">{{ app?.applicationDescription }}</p>
              </div>
            </div>
          </a>
        </ng-template>
      </swiper>
    </div>
    <div class="nav">
      <i class="caret right teal big icon link" (click)="slideNext()"></i>
    </div>
  </div>

  <div class="text-right link" appPadding paddingY="3" paddingX="15">
    <a routerLink="/contractor/application">View All</a>
  </div>
</div>
